module.exports = __webpack_public_path__ + "media/images/vedett_allatok/Vedett-belyeg_0000__-db6d7433f76c3322d1393aea2669f964.png";